import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import GenevaCommunity from './components/GenevaCommunity';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<GenevaCommunity />} />
      </Routes>
    </Router>
  );
}

export default App;
